var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'overlay-card': _vm.loading
    }
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "loading-spinner mx-auto mt-auto mb-auto",
    attrs: {
      "type": "grow",
      "variant": "primary"
    }
  }) : _vm._e(), _vm._t("overlay-body")], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }